Auth = require 'db/auth'
getExperiment = require 'lib/experiments/simple-test'
ldclient = require 'lib/ldclient'
LocalStorageModel = require 'view-models/internal/local-storage-model'

# Guided tour state is global across the application, but unique per member
module.exports = new class extends LocalStorageModel
  # Step enums
  WELCOME: 0
  CARD: 1
  CARD_BACK: 2
  LIST: 3
  INVITE: 4
  COMPLETE: 5

  constructor: ->
    super
    @set({ id: "guidedTour-#{ Auth.myId() }" })
    @fetch()
    @enableTabSync()

  default: ->
    currentStep: @WELCOME
    visible: true

  show: ->
    @update('visible', true)
  hide: ->
    @update('visible', false)

  getStep: -> @get('currentStep')
  setStep: (currentStep) ->
    @update('currentStep', currentStep)
    @update('visible', true)

  setBoard: (idBoard, url) ->
    if !@get('idBoard') || !@get('boardUrl') || @get('idBoard') !in Auth.me()?.get('idBoards') ? []
      @update('idBoard', idBoard)
      @update('boardUrl', url)

  isBoardForTour: (idBoard) ->
    # Let tour resume on another board if the original board that initiated the
    # tour is deleted.
    @get('idBoard') !in (Auth.me()?.get('idBoards') ? []) || @get('idBoard') == idBoard

  isEnabled: ->
    getExperiment('onboarding').get('variation') == 'guidedTour' &&
      !Auth.me()?.isGuidedTourDismissed()

  isVisible: ->
    @isEnabled() && @get('visible')

  hasStartedTour: ->
    @isVisible() && @getStep() == @CARD

  hasCreatedCard: ->
    @isVisible() && @getStep() == @CARD_BACK

  hasAddedDescription: ->
    @isVisible() && @getStep() == @LIST

  hasInvitedMember: ->
    @isVisible() && @getStep() == @INVITE

  hasCompletedTour: ->
    @isVisible() && @getStep() == @COMPLETE

  startTour: ->
    @setStep(@CARD)

  completeTour: ->
    @setStep(@COMPLETE)

  propagateUpdate: ->
    @trigger('change:currentStep')

  onStorage: (ev) ->
    @setStep(@getStep())



// WEBPACK FOOTER //
// ./app/scripts/view-models/guided-tour-state.coffee